export const openBankingConstants = {
  GET_ACCOUNTS: 'OPEN_BANKING_GET_ACCOUNTS',
  APPEND_ACCOUNTS: 'OPEN_BANKING_APPEND_ACCOUNTS',
  SET_ACCOUNTS_LOADING: 'OPEN_BANKING_SET_ACCOUNTS_LOADING',
  SET_ACCOUNTS_LOADED: 'OPEN_BANKING_SET_ACCOUNTS_LOADED',
  SET_ACCOUNTS_ERROR: 'OPEN_BANKING_SET_ACCOUNTS_ERROR',
  GET_CONNECTIONS: 'OPEN_BANKING_GET_CONNECTIONS',
  APPEND_CONNECTIONS: 'OPEN_BANKING_APPEND_CONNECTIONS',
  SET_CONNECTIONS_LOADING: 'OPEN_BANKING_SET_CONNECTIONS_LOADING',
  SET_CONNECTIONS_ERROR: 'OPEN_BANKING_SET_CONNECTIONS_ERROR',
  UPDATE_CONNECTION: 'OPEN_BANKING_UPDATE_CONNECTION',
  UPDATE_CONNECTION_STATUS: 'OPEN_BANKING_UPDATE_CONNECTION_STATUS',
  UPDATE_ACCOUNT: 'OPEN_BANKING_UPDATE_ACCOUNT',
  UPDATE_ACCOUNTS: 'OPEN_BANKING_UPDATE_ACCOUNTS',
  SET_CONNECTION_CREATING: 'OPEN_BANKING_SET_CONNECTION_CREATING',
  CREATE_CONNECTION: 'OPEN_BANKING_CREATE_CONNECTION',
  CREATE_CONNECTION_ERROR: 'OPEN_BANKING_CREATE_CONNECTION_ERROR',
  CLOSE_CONNECT_MODAL: 'OPEN_BANKING_CLOSE_CONNECT_MODAL',
  ADD_CONNECTION: 'OPEN_BANKING_ADD_CONNECTION',
  REMOVE_CONNECTION: 'OPEN_BANKING_REMOVE_CONNECTION',
  ACCOUNTS_REFRESH_DONE: 'OPEN_BANKING_ACCOUNTS_REFRESH_DONE',
  SET_FIRST_NEW_ACCOUNT_ID: 'OPEN_BANKING_SET_FIRST_NEW_ACCOUNT_ID',
  CLEAR_FIRST_NEW_ACCOUNT_ID: 'OPEN_BANKING_CLEAR_FIRST_NEW_ACCOUNT_ID',
  SET_PENDING_ACCOUNT_REFRESH: 'OPEN_BANKING_SET_PENDING_ACCOUNT_REFRESH',
  CLEAR_PENDING_ACCOUNT_REFRESH: 'OPEN_BANKING_CLEAR_PENDING_ACCOUNT_REFRESH',
  SET_ACCOUNT_ACCESS: 'OPEN_BANKING_SET_ACCOUNT_ACCESS',
  ADD_ACCOUNT_ACCESS: 'OPEN_BANKING_ADD_ACCOUNT_ACCESS',
  SET_OB_PAYMENT_METHODS: 'OPEN_BANKING_SET_OB_PAYMENT_METHODS',
  APPEND_OB_PAYMENT_METHODS: 'OPEN_BANKING_APPEND_OB_PAYMENT_METHODS',
  CLEAR_OPEN_BANKING_DATA: 'OPEN_BANKING_CLEAR_DATA',
};
